export default __webpack_public_path__ + "static/media/cassandra.2c3d646c.jpeg";